import {getRegisteredNode} from "@cm/graph-v3"
import {MaterialAssignmentConstructorParameters, MaterialAssignmentParameters, MaterialLikeNode, TemplateNode} from "@cm/template-nodes"

export function createMaterialAssignmentLikeNode<T extends TemplateNode<MaterialAssignmentParameters, MaterialAssignmentConstructorParameters>>(
    materialLike: MaterialLikeNode,
    side: MaterialAssignmentParameters["side"],
    nodeClass: string,
): T {
    const NodeClass = getRegisteredNode(nodeClass, "template")
    return new NodeClass({parameters: {node: materialLike, side}}) as T
}
